'use client';

import { Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

const FacetDescription = ({ count, isRecommended }: { count: number; isRecommended: boolean }) => {
  const { t } = useTranslation('webshop.filterPage');

  return (
    <>
      <Typography variant='caption' component='span' mr={isRecommended ? 200 : 0}>
        ({count})
      </Typography>
      {isRecommended && (
        <Typography component='span' color='sentimentPositive' display='inline-block'>
          {t('facets.recommendedLabel')}
        </Typography>
      )}
    </>
  );
};

export { FacetDescription };
